import ValidateUserForm from 'src/components/Form/ValidateUserForm'
import Modal from 'src/components/Modal'
import Button from 'src/components/Button'
import Text from 'src/components/Text'
import { DarkRedHover, Red } from 'src/assets/colors'
import { actions } from 'src/features/state'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { selectUserBarcode } from 'src/features/selector'
import stockApi from 'src/services/StockApi'

interface Props {
  user: any,
  queueRow: any,
  handleCloseModalRemoveSupplierQueue: any,
  openModalRemoveProviderQueue: any,
  updateCurrentTab: any
}

export const CancelReceivementModal = (
  {
    user,
    queueRow,
    handleCloseModalRemoveSupplierQueue,
    openModalRemoveProviderQueue,
    updateCurrentTab,
  }: Props,
) => {
  const dispatch = useDispatch()
  const [errorsRemoveProvider, setErrorsRemoveProvider] = useState<string>()
  const userBarcode = useSelector(selectUserBarcode)

  const handleRemoveSupplierQueue = () => {
    setErrorsRemoveProvider(undefined)
    const data = {
      receivement_id: queueRow.receivement_id,
      user_barcode: userBarcode,
    }
    stockApi
      .delete('/receivement/queue', { data })
      .then(() => {
        handleCloseModalRemoveSupplierQueue()
        updateCurrentTab()
        dispatch(actions.setUserBadge(false))
      })
      .catch((err) => {
        if (err.response) {
          const errorData = err.response.data
          setErrorsRemoveProvider(errorData.message)
        } else {
          setErrorsRemoveProvider(
            'Não foi possível completar a requisição, verifique a conexão com a internet',
          )
        }
      })
  }

  return (
    <Modal
      title='Cancelar Atendimento'
      body={(
        <div style={{ padding: '15px' }}>
          {user ? (
            <>
              <div style={{ textAlign: 'center' }}>
                <Text
                  style={{ fontSize: '14px' }}
                  plainText='Deseja realmente cancelar o atendimento do fornecedor:'
                />
                <Text
                  style={{ fontSize: '20px', fontWeight: 'semibold' }}
                  plainText={queueRow.supplier}
                />
              </div>
              <div>
                {errorsRemoveProvider && (
                <Text
                  style={{ fontSize: '14px', color: Red }}
                  plainText={errorsRemoveProvider}
                />
                )}
              </div>
              <div
                style={{
                  borderTop: '1px solid #C4C4C4',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  marginTop: '10px',
                  paddingTop: '10px',
                }}
              >
                <Button
                  text='yes'
                  style={{ height: '34px' }}
                  onClick={handleRemoveSupplierQueue}
                />
                <Button
                  text='no'
                  style={{ height: '34px' }}
                  color={Red}
                  hoverColor={DarkRedHover}
                  onClick={handleCloseModalRemoveSupplierQueue}
                />
              </div>
            </>
          ) : (
            <>
              <div>
                <ValidateUserForm />
              </div>
              <div
                style={{
                  borderTop: '1px solid #C4C4C4',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginTop: '10px',
                  paddingTop: '10px',
                }}
              >
                <Button
                  text='cancel'
                  style={{ height: '34px' }}
                  color={Red}
                  hoverColor={DarkRedHover}
                  onClick={handleCloseModalRemoveSupplierQueue}
                />
              </div>
            </>
          )}
        </div>
          )}
      closedButton
      closeButtonAction={() => {
        handleCloseModalRemoveSupplierQueue()
        dispatch(actions.setUserBadge(false))
      }}
      show={openModalRemoveProviderQueue}
      centered
    />
  )
}
